module.exports = __webpack_public_path__ + "static/img/banner.c933a4b3.jpg";